<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ editData.inquiry.full_name_en }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form class="form-horizontal">
        <div class="row form-group m-b-15">
          <label class="col-form-label col-md-3 required">{{
            $t('studentFollowUp.actionStatus')
          }}</label>
          <div class="col-md-7">
            <treeselect
              :options="
                status.map(el => ({
                  id: el.value,
                  label: el.value
                }))
              "
              :placeholder="$t('typeForSearch')"
              v-model="model.action_status"
            ></treeselect>
            <div class="validate" v-if="errors.has('action_status')">
              {{ errors.first('action_status') }}
            </div>
          </div>
        </div>
        <div class="row form-group m-b-15" v-show="model.action_status !== 'Accepted'">
          <label
            class="col-form-label col-md-3"
            :class="model.action_status == 'Follow Up' ? 'required' : ''"
            >{{ $t('studentFollowUp.nextAction') }}</label
          >
          <div class="col-md-7">
            <!-- <ts-date-picker-input v-model="model.next_action_date"/> -->
            <a-date-picker
                      v-model="model.next_action_date"
                      format="DD-MM-YYYY"
                      valueFormat="DD-MM-YYYY"
                      :disabled-date="disabledDate"
                      class="ts-w-full"
                    ></a-date-picker>
            <div class="validate" v-if="errors.has('next_action_date')">
              {{ errors.first('next_action_date') }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-form-label col-md-3 required">{{
            $t('studentFollowUp.comments')
          }}</label>
          <div class="col-md-7">
            <textarea
              v-model="model.comments"
              class="form-control"
              :class="{ 'is-invalid': errors.has('comments') }"
              rows="4"
            ></textarea>
            <div class="invalid-feedback" v-if="errors.has('comments')">
              {{ errors.first('comments') }}
            </div>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-sm-12 text-right">
            <ts-button class="btn-default" @click.prevent="$emit('close')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              class="btn-primary ml-2"
              @click.prevent="update"
              :waiting="saving"
              >{{ $t('update') }}</ts-button
            >
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import debounce from 'lodash/debounce'

export default {
  name: 'student-follow-up-edit',
  props: ['editData'],
  data () {
    return {
      model: {
        action_status: '',
        action_date: '',
        next_action_date: '',
        comments: ''
      },
      errors: new Errors(),
      saving: false,
      status: [
        {
          value: 'Follow Up'
        },
        {
          value: 'Accepted'
        },
        {
          value: 'Rejected'
        }
      ]
    }
  },
  created () {
    this.setEditData()
  },
  methods: {
    setEditData () {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          next_action_date: this.editData.next_action_date
        }
      }
    },

    disabledDate (current) {
      let current_date = new Date() // Current date and time
      let allow_date = new Date(current_date) // Create a new Date object with the current date and time
      allow_date.setDate(
        current_date.getDate() - 1
      )
      return current && current.valueOf() < allow_date
    },

    update () {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('studentFollowUp/update', {
          followup_id: this.editData.followup_id,
          ...this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  },
  watch: {
    'model.action_status': debounce(function (value) {
      this.model.next_action_date = ''
    }, 10)
  }
}
</script>
